module.exports = __webpack_public_path__ + "static/media/camion_completo.a156c7d6.svg";